import { ChevronDownIcon } from '@assets/icons/ChevronIcon';
import { cn } from '@components/shadcn/utils';
import { useLocalStorage } from '@hooks/useLocalStorage';
import { routePaths } from '@screens/routes';
import { Popover } from 'antd';
import { t } from 'i18next';
import { useState } from 'react';
import { useMatch, useSearchParams } from 'react-router-dom';
import { SeasonPopover } from '.';
import { AIInsightTooltip } from './AIInsightTooltip';
import { SeasonPopoverTitle } from './SeasonPopoverTitle/SeasonPopoverTitle';

const AI_INSIGHTS_SEASON_TOOLTIP_DISMISS_KEY = 'ai_insights_season_tooltip_dismissed';

export function SeasonPopoverWrapper() {
  const [params] = useSearchParams();
  const [visible, setVisible] = useState(false);
  const isOnAnomalyDetectionSettings = params.get('settingsModal') === 'AnomalyDetection';

  const aiInsightsMatch = !!useMatch({ path: routePaths.aiInsights, end: false });
  const [dismissed, setDismissed] = useLocalStorage(
    AI_INSIGHTS_SEASON_TOOLTIP_DISMISS_KEY,
    false,
    'localstorage'
  );

  const insightTooltipOpen = aiInsightsMatch && !dismissed;

  return (
    <Popover
      align={{ offset: [0, 8] }}
      placement="bottomLeft"
      content={<SeasonPopover visible={visible} close={() => setVisible(false)} />}
      overlayClassName={
        '[&_.ant-popover-arrow]:hidden [&_.ant-popover-inner]:rounded-md [&_.ant-popover-inner-content]:p-1 [&_.ant-popover-inner-content]:pt-3'
      }
      trigger="click"
      visible={isOnAnomalyDetectionSettings ? false : visible}
      onVisibleChange={(isVisible) => {
        setVisible(isVisible);
        if (isVisible) {
          setDismissed(true);
        }
      }}
    >
      <AIInsightTooltip open={insightTooltipOpen} onClose={() => setDismissed(true)}>
        <div
          className={cn(
            'flex items-center py-1 px-2 gap-1 rounded cursor-pointer hover:bg-sy-blue-20',
            {
              ['opacity-30 !cursor-not-allowed select-none hover:!bg-transparent']: isOnAnomalyDetectionSettings,
            }
          )}
        >
          <div className="flex flex-col">
            <span className="text-xs text-sy-neutral-60">{t('header.seasons.title')}</span>
            <SeasonPopoverTitle />
          </div>
          <span className={cn('pb-[1px] self-end transition', { 'rotate-180': visible })}>
            <ChevronDownIcon />
          </span>
        </div>
      </AIInsightTooltip>
    </Popover>
  );
}
